import { render, staticRenderFns } from "./jsonDataLayout.vue?vue&type=template&id=3a6b8f8f&"
import script from "./jsonDataLayout.vue?vue&type=script&lang=js&"
export * from "./jsonDataLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports